import { useEffect } from "react";
import axios from "axios";
import { API } from "@/utils/constants";

const stripBadge = (t) => t.replace(/^\(\d+\)\s/, "");

export const TitleBadge = () => {
  useEffect(() => {
    let stopped = false;
    const update = async () => {
      try {
        const r = await axios.get(`${API}/chat/channels`);
        if (stopped) return;
        const unread = r.data.reduce((sum, c) => sum + (c.unread || 0), 0);
        const clean = stripBadge(document.title);
        document.title = unread > 0 ? `(${unread}) ${clean}` : clean;
        if ("setAppBadge" in navigator) {
          if (unread > 0) navigator.setAppBadge(unread).catch(() => {});
          else navigator.clearAppBadge?.().catch(() => {});
        }
      } catch {}
    };
    update();
    const iv = setInterval(update, 30000);
    let debounce = null;
    const onWS = () => { clearTimeout(debounce); debounce = setTimeout(update, 500); };
    window.addEventListener("chat-message-received", onWS);
    return () => {
      stopped = true;
      clearInterval(iv);
      clearTimeout(debounce);
      window.removeEventListener("chat-message-received", onWS);
      document.title = stripBadge(document.title);
    };
  }, []);
  return null;
};
